import React from "react";
import "../styles/loading";

export default class Loading extends React.Component {
	render()
	{
		return (
				<div className="lds-css ng-scope">
					<div className="lds-spinner" style={{"width": "100px", "height": "100px"}}>
						<div/>
						<div/>
						<div/>
						<div/>
						<div/>
						<div/>
						<div/>
						<div/>
						<div/>
						<div/>
						<div/>
						<div/>
					</div>
				</div>
		);
	}
}